import { useState, useEffect } from "react";
import ColorSchema from "../Color/index.tsx";
export default function CustomButton({
  children,
  className,
  style = {},
  color = ColorSchema.secondary_custom,
  size = "medium",
  type = "base",
  state = "normal",
  circle = false,
  btnType = "button",
  onClick
}) {
  // type buttonColor = "primary" | "info" | "success" | "warning";
  // type buttonType = "base" | "label" | "outline" | "text";
  // type buttonState = "normal" | "active" | "deactive";
  // type buttonSize = "larger" | "large" | "medium" | "smaller" | "small"
  // type circle = true | false
  const [buttonType, setButtonType] = useState({});
  const [buttonSize, setButtonSize] = useState({});

  useEffect(() => {
    // type
    switch (type) {
      case "base":
        setButtonType(prev => {
          return {
            ...prev,
            backgroundColor: ColorSchema[`${color}_custom`],
            color: ColorSchema[`white_custom`],
            boxShadow: "2px 2px 2px 2px rgba(238,238,238,0.3)"
          };
        });
        break;
      case "label":
        setButtonType(prev => {
          return {
            ...prev,
            backgroundColor: ColorSchema[`${color}_light_custom`],
            color: ColorSchema[`${color}_custom`]
          };
        });
        break;
      case "outline":
        setButtonType(prev => {
          return {
            ...prev,
            backgroundColor: "",
            color: ColorSchema[`${color}_custom`],
            borderColor: ColorSchema[`${color}_custom`],
            borderWidth: "1px",
            borderType: "solid"
          };
        });
        break;
      case "text":
        setButtonType(prev => {
          return {
            ...prev,
            color: ColorSchema[`${color}_custom`],
            boxShadow: "none"
          };
        });
        break;
      default:
        setButtonType(prev => {
          return {
            ...prev,
            backgroundColor: ColorSchema[`${color}_custom`],
            color: ColorSchema[`white_custom`]
          };
        });
        break;
    }
    // size
    switch (size) {
      case "larger":
        setButtonSize(prev => {
          return { ...prev, height: 58, fontSize: 20 };
        });
        break;
      case "large":
        setButtonSize(prev => {
          return { ...prev, height: 50, fontSize: 17 };
        });
        break;
      case "medium":
        setButtonSize(prev => {
          return { ...prev, height: 38, fontSize: 15 };
        });
        break;
      case "small":
        setButtonSize(prev => {
          return { ...prev, height: 26, fontSize: 13 };
        });
        break;
      case "smaller":
        setButtonSize(prev => {
          return { ...prev, height: 22, fontSize: 12 };
        });
        break;
      default:
        setButtonSize(prev => {
          return { ...prev, height: 38, fontSize: 15 };
        });
        break;
    }
    if (state == "active" && (type == "label" || type == "outline")) {
      setButtonType(prev => {
        return {
          ...prev,
          backgroundColor: ColorSchema[`${color}_custom`],
          color: ColorSchema[`white_custom`]
        };
      });
    }
  }, []);
  const mouseEnter = () => {
    if (type == "label" || type == "outline") {
      setButtonType(prev => {
        return {
          ...prev,
          backgroundColor: ColorSchema[`${color}_custom`],
          color: ColorSchema[`white_custom`]
        };
      });
    } else if (type == "base") {
      setButtonType(prev => {
        return {
          ...prev,
          opacity: 0.7,
          boxShadow: "5px 5px 5px 5px rgba(238,238,238,0.3)"
        };
      });
    }
  };
  const mouseLeave = () => {
    if (type == "label" && state != "active") {
      setButtonType(prev => {
        return {
          ...prev,
          backgroundColor: ColorSchema[`${color}_light_custom`],
          color: ColorSchema[`${color}_custom`]
        };
      });
    } else if (type == "outline" && state != "active") {
      setButtonType(prev => {
        return {
          ...prev,
          backgroundColor: "",
          color: ColorSchema[`${color}_custom`],
          borderColor: ColorSchema[`${color}_custom`],
          borderWidth: "1px",
          borderType: "solid"
        };
      });
    } else if (type == "base") {
      setButtonType(prev => {
        return {
          ...prev,
          opacity: 1,
          boxShadow: "2px 2px 2px 2px rgba(238,238,238,0.3)"
        };
      });
    }
  };
  return (
    <>
      <button
        className={`btn d-flex align-items-center ${className}`}
        type={btnType}
        onClick={onClick}
        style={{
          ...style,
          height: buttonSize.height,
          fontSize: buttonSize.fontSize,
          borderRadius: circle ? "50rem" : "0.25rem",
          borderColor: state == "deactive" && "transparent",
          ...buttonType
        }}
        onMouseOver={mouseEnter}
        onMouseLeave={mouseLeave}
        disabled={state == "deactive" ? true : false}
        checked={state == "active" ? true : false}
      >
        {children}
      </button>
    </>
  );
}
